import type { Component } from 'vue';

import Box from './Box.vue';
import Gap from './gap.vue';

export default new Map<string, Component>([
  ['Box', Box],
  ['Gap', Gap],
]);